import React from "react";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import TimelapseIcon from "@material-ui/icons/Timelapse";

const navigation = [
  {
    title: "Orders",
    path: "/",
    icon: <ShoppingBasketIcon />,
    children: []
  },
  {
    title: "Orders History",
    path: "/orders/history",
    icon: <TimelapseIcon />,
    children: []
  }
];

export default navigation;
